import basicRequest from "../../../../core/redux/actions/request";

import { onChangeInPointOfSales } from "../../cache/l4";

const PREFIX = "MANAGER_PROJECT_FORM_POS";
const getState = (state) => state.manager.project.formPos;

const {
    reset,

    getPattern,
    getEmptyRequestPattern,
    secondaryPostPattern,
    secondaryPutPattern,

    isLoading,
    isLoaded,
    getError,
    getData,
    getSecondaryData,
    getSecondarySuccess: getFormSuccess,
} = basicRequest(PREFIX, getState);

export const load = (id, posId) => {
    let url = "manager/v1/projects/" + id;
    if (posId != null) {
        url = "manager/v1/projects/" + id + "/point-of-sale/form/" + posId;
    }

    return getPattern(url, {});
};

export const create = (id, form) =>
    secondaryPostPattern(
        "manager/v1/projects/" + id + "/point-of-sale/form",
        form,
        onChangeInPointOfSales({
            message: "Created",
            description: "The point of sale was created.",
        })
    );
export const update = (id, posId, form) =>
    secondaryPutPattern(
        "manager/v1/projects/" + id + "/point-of-sale/form/" + posId,
        form,
        onChangeInPointOfSales({
            message: "Updated",
            description: "The point of sale was updated.",
        })
    );

export { reset, getData, isLoaded, isLoading, getError, getSecondaryData, getFormSuccess };
